export const getRoutesOfEA = (builder) => ({
    getRoutesOfEA: builder.mutation({
        query: ({ user_id }) => {
            const token = JSON.parse(localStorage.getItem('TOKEN'))?.token || '';

            return {
                url: `/get_list_route_acc_enterprise_admin`,
                method: 'GET',
                params: { user_id },
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                },
            };
        },
    }),
})